import { lazy } from 'react';
import { FINANCE_PERMISSIONS } from './constants';

const InvoiceListPage = lazy(() => import('./pages/InvoiceListPage'));
const InvoiceDetailPage = lazy(() => import('./pages/InvoiceDetailPage'));
const PaymentListPage = lazy(() => import('./pages/PaymentListPage'));
const PaymentDetailPage = lazy(() => import('./pages/PaymentDetailPage'));
const InstallmentListPage = lazy(() => import('./pages/InstallmentListPage'));
const WalletListPage = lazy(() => import('./pages/WalletListPage'));
const WithdrawalRequestListPage = lazy(() => import('./pages/WithdrawalRequestListPage'));

export const financeRoutes = [
  {
    path: '/invoices',
    element: InvoiceListPage,
    permission: FINANCE_PERMISSIONS.READ,
    nav: { labelKey: 'nav.invoices', icon: 'FileDoneOutlined', group: 'finance' },
  },
  { path: '/invoices/:id', element: InvoiceDetailPage, permission: FINANCE_PERMISSIONS.READ, nav: null },
  {
    path: '/payments',
    element: PaymentListPage,
    permission: FINANCE_PERMISSIONS.READ,
    nav: { labelKey: 'nav.payments', icon: 'DollarOutlined', group: 'finance' },
  },
  { path: '/payments/:id', element: PaymentDetailPage, permission: FINANCE_PERMISSIONS.READ, nav: null },
  {
    path: '/wallets',
    element: WalletListPage,
    permission: FINANCE_PERMISSIONS.READ,
    nav: { labelKey: 'nav.wallets', icon: 'WalletOutlined', group: 'finance' },
  },
  {
    path: '/withdrawal-requests',
    element: WithdrawalRequestListPage,
    permission: FINANCE_PERMISSIONS.READ,
    nav: { labelKey: 'nav.withdrawalRequests', icon: 'ExportOutlined', group: 'finance' },
  },
  {
    path: '/installments',
    element: InstallmentListPage,
    permission: FINANCE_PERMISSIONS.READ,
    nav: { labelKey: 'nav.installments', icon: 'CalendarOutlined', group: 'finance' },
  },
];
